// Plain form, so single-spa registration (apps.ts) — which runs outside React —
// gates on the same rule the sidebar and the debug badge use.
export const isStageOrDev = (): boolean => {
  const env = import.meta.env.VITE_REACT_APP_NODE_ENV || import.meta.env.MODE;
  if (
    env === "staging" ||
    env === "stage" ||
    env === "development" ||
    env === "dev"
  ) {
    return true;
  }
  // Marlin desktop dev flow renders the shell over app:// (hostname "bundle"),
  // so honour the injected dev marker / MFE override map (matches
  // DebugBadge's isDebugEnvironment).
  if (globalThis.__MARLIN_DESKTOP_DEV__) return true;
  const overrides = globalThis.__MFE_DEV_OVERRIDES__;
  if (overrides && Object.keys(overrides).length > 0) return true;
  // Production builds resolve MODE to "production" regardless of target env, so
  // fall back to the host: prod is mfe.observe.tech, staging is
  // mfe.staging.observe.tech (matches DebugBadge's isDebugEnvironment).
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") return true;
    if (host.endsWith("staging.observe.tech")) return true;
  }
  return false;
};

export const useIsStageOrDev = () => isStageOrDev();
